import { Navigate, Route, Routes } from "react-router-dom";

import { UserRole } from "../types/user";
import useAuth from "../hooks/useAuth";
import AdminRoutes from './AdminRoutes';
import FeatureRoutes from "./FeatureRoutes";
import RoleGuard from "../guards/RoleGuard";

import DashBoardLayout from "../components/layouts/DashBoardLayout";
import Home from "../pages/home/Home";
import Profile from "../pages/profile/Profile";
// import Help from "../pages/auth/help/Help";
import OwnObjects from "../pages/objects/OwnObjects";
import Users from "../pages/users/Users";

const ProtectedRoutes = () => {
  const {canAccessAdminDashboard: canAccessAdmin} = useAuth();

  return (
    <Routes>
      <Route Component={DashBoardLayout}>
        <Route index element={canAccessAdmin() ? <Navigate to='admin' relative="route" /> : <Home />} />
        <Route path="admin/*" element={<RoleGuard role={[UserRole.admin, UserRole.site_admin, UserRole.operator]}><AdminRoutes/></RoleGuard>} />
        <Route path="feature/*" element={<RoleGuard role={UserRole.operator}><FeatureRoutes /></RoleGuard>} />
        <Route path="own-objects" element={<RoleGuard role={UserRole.operator}><OwnObjects /></RoleGuard>} />
        <Route path="users" element={<RoleGuard role={[UserRole.admin, UserRole.site_admin]}><Users /></RoleGuard>} />
        {/* <Route path="help"  element={<RoleGuard role={UserRole.operator}><Help /></RoleGuard>} /> */}
        <Route path="profile" Component={Profile} />
      </Route>
    </Routes>
  )
}

export default ProtectedRoutes;